export default {
//		tradeDetail:{
//		item_count:0,
//		list:[],
//		total_count:0
//	}
tradeDetail:[]
}



// WEBPACK FOOTER //
// ./src/store/mp/pay_manage/data_analyse/state.js